// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10Tpa","colBig":"styles_colBig__2AMB2","colSmall":"styles_colSmall__2_0XR","shopifyNameWrapper":"styles_shopifyNameWrapper__1lYMd"};